//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import vehicleProvision from './vehicleProvision.js'
import { bussinessProcessObjectInitialization } from '../../components/BusinessProcess/bussinessProcessObjectInitialization.js'
import BussinessProcessButton from '../../components/BusinessProcess/BussinessProcessButton.vue'
import BussinessProcessButtons from '../../components/BusinessProcess/BussinessProcessButtons.vue'
import VehicleProvisionRequest from './components/VehicleProvisionRequest.vue'
import BusinessProcessCurrentEventMobile from '../../components/BusinessProcess/BusinessProcessEvents/BusinessProcessCurrentEventMobile.vue'
import BusinessProcessEventsHistoryDispatcher from '../../components/BusinessProcess/BusinessProcessEvents/BusinessProcessEventsHistoryDispatcher.vue'
import CardSeparator from '../../components/Card/CardSeparator.vue'
import TableCellAlarm from '../../components/Table/TableCellAlarm.vue'

export default {
  components: {
    BussinessProcessButton,
    BussinessProcessButtons,
    VehicleProvisionRequest,
    BusinessProcessCurrentEventMobile,
    BusinessProcessEventsHistoryDispatcher,
    CardSeparator,
    TableCellAlarm
  },
  extends: vehicleProvision,
  mixins: [bussinessProcessObjectInitialization],
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonSave: function () {
      return this.vehicleProvision.actions.find(action => action.id === 'save')
    },
    buttonCopy: function () {
      return this.vehicleProvision.actions.find(action => action.id === 'copy')
    },
    orderNumber: function () {
      const request = this.vehicleProvision.request
      return request && request.orderNumber || null
    },
    workShiftLabelData: function () {
      const request = this.vehicleProvision.request
      if (request) {
        const serviceTime = request.serviceTimeRequiredInitial || request.serviceTimeRequired || null
        if (serviceTime) {
          const valueHour = new Date(serviceTime).getHours()
          if (valueHour >= 19 || valueHour < 7) {
            return {
              text: 'Ночь',
              style: this.getWorkShiftLabelStyle('#666666', 'white')
            }
          } else {
            return {
              text: 'День',
              style: this.getWorkShiftLabelStyle('white', 'black')
            }
          }
        }
      }
      return null
    }
  },
  watch: {
    '$route.params.id': {
      handler: function (id) {
        if (this.vehicleProvisionId && this.dialog) {
          this.loadInDispatcher(this.vehicleProvisionId)
        } else if (id != null) {
          if (id === 'create') {
            id = -1
          }
          this.loadInDispatcher(id)
        }
      },
      immediate: true
    }
  },
  methods: {
    onClose: function () {
      this.close()
    },
    close: function () {
      if (!this.dialog) {
        if (window.history.length != 1 && window.history.state !== null) {
          this.$router.back()
        } else {
          this.$router.push('/')
        }
      } else {
        this.$emit('cancel')
      }
    },
    loadInDispatcher: function (id) {
      if (id !== -1 && this.$route.params.id === 'create') {
        this.$router.replace('/transport/vehicleProvision/vehicleProvisionRequests/' + id)
      } else {
        this.load(id, this.additionalParams).then(() => {
          if (this.additionalParams) {
            this.additionalParams = null
          }
        })
      }
    },
    getWorkShiftLabelStyle: function (bgColor, color, fontWeight = 500) {
      return `font-weight: ${fontWeight};
          background-color: ${bgColor};
          color: ${color};`
    }
  }
}

